export const params = new URLSearchParams(window.location.search)

export const language = params.get('language') ?? 'en'

export const platform = params.get('platform') as
  | 'ios'
  | 'googleplay_android'
  | 'china_android'
